import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './ConfirmModalButtonFooter.module.css';

export type ConfirmModalButtonFooterProps = ComponentProps<'div'> & {
  /** default: End */
  buttonAlignment?: ConfirmModalButtonFooterButtonAlignment;
};

export enum ConfirmModalButtonFooterButtonAlignment {
  End = 'end',
  SpaceBetween = 'spaceBetween'
}

export const ConfirmModalButtonFooter: FunctionComponent<ConfirmModalButtonFooterProps> =
  React.memo((props) => {
    const {
      buttonAlignment = ConfirmModalButtonFooterButtonAlignment.End,
      children,
      className,
      ...remainingProps
    } = prepareProps({ props });

    return (
      <div
        {...remainingProps}
        className={classes(
          className,
          styles.footer,
          buttonAlignmentToClassName[buttonAlignment]
        )}
      >
        {children}
      </div>
    );
  });

const buttonAlignmentToClassName: Record<
  ConfirmModalButtonFooterButtonAlignment,
  string | null
> = {
  [ConfirmModalButtonFooterButtonAlignment.End]: styles.buttonAlignmentEnd,
  [ConfirmModalButtonFooterButtonAlignment.SpaceBetween]:
    styles.buttonAlignmentSpaceBetween
};
